import styled from 'styled-components';

export const Root = styled.div<{ $disableHover?: boolean }>`
  width: 100%;
  border: none;
  padding: 0px;

  :hover {
    ${({ $disableHover, theme }) =>
      $disableHover ? '' : `background-color: ${theme.colors.grey2};`}
  }
`;
